<template>
  <!-- Chip de estado flotante (abajo-centro). Reemplaza la barra de estado del
       footer eliminado: muestra la vista activa y el nº de elementos seleccionados.
       Ubicación provisional; se afinará más adelante. Solo informativo. -->
  <div class="epc-status">
    <!-- Diseño: "<vista> en modo diseño" (deja claro el modo). Vista: "Visualizando <vista>". -->
    <span v-if="designMode" class="epc-status-item">
      <span class="epc-status-value lowercase">{{ nameVista }}</span>
      <span class="epc-status-verb">{{ $t('in_design_mode') }}</span>
    </span>
    <span v-else class="epc-status-item">
      <span class="epc-status-verb">{{ $t('viewing') }}</span>
      <span class="epc-status-value lowercase">{{ nameVista }}</span>
    </span>

    <!-- Nº de elementos seleccionados: solo cuando hay alguno. -->
    <template v-if="selectedCount > 0">
      <span class="epc-status-sep">·</span>
      <span class="epc-status-item">
        <span class="epc-status-label">{{ $t('selected_elements') }}:</span>
        <span class="epc-status-value">{{ selectedCount }}</span>
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: "ViewerStatusDesign",

  props: {
    nameVista: { type: String, default: null },
    selectedCount: { type: Number, default: 0 },
    designMode: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.epc-status {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(255, 255, 255, 0.92);
  border: 1px solid #e3e3e8;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12);
  padding: 4px 10px;
  font-size: 12px;
  color: #495057;
  pointer-events: none;
  z-index: 6;
  white-space: nowrap;
}

.epc-status-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.epc-status-label {
  color: #868e96;
}

.epc-status-value {
  font-weight: 600;
  color: #343a40;
}

.epc-status-sep {
  color: #cfcfd6;
}

.epc-status-verb {
  color: #3a6bc8;
  font-weight: 700;
}
</style>
